import request from '@/utils/request'
import { Consulation } from '@/interface/api'
import { PostConsultationType } from '@/views/treatment-reservation/templates/ConsultationForm/api'

export const retrieveConsultations = (
  medicalBusinessId: string,
  clinicId: string,
  clinicalDepartmentId: string,
  isFirst: number
): Promise<Consulation> =>
  request({
    url: `/api/v0/customer/clinics/consultations/${medicalBusinessId}/${clinicId}/${clinicalDepartmentId}`,
    params: { is_first_treatment: isFirst },
    method: 'get'
  }).then(response => response.data.data.attributes)

export const postConsultations = (
  medicalBusinessId: string,
  customerId: string,
  treatmentId: string,
  clinicFormId: string,
  data: PostConsultationType,
  uploadFiles: { file: File; key: string }[]
): Promise<boolean> => {
  const formData = new FormData()
  formData.append('consultation_json', JSON.stringify(data))
  uploadFiles.forEach(uploadFile => {
    formData.append(uploadFile.key, uploadFile.file)
  })
  return request({
    url: `/api/v0/customer/clinics/consultations/answer/${customerId}/${medicalBusinessId}/${treatmentId}/${clinicFormId}/`,
    method: 'POST',
    data: formData
  }).then(response => response.data.data.attributes)
}
